import { CustomCellRendererProps } from 'ag-grid-react'

import { useTopLevelBucketsQuery } from '@/react-query/queries/static'

export interface TopLevelBucketIdCellRendererProps extends CustomCellRendererProps {}

export const TopLevelBucketIdCellRenderer: React.FC<TopLevelBucketIdCellRendererProps> = ({
  value,
}) => {
  const query = useTopLevelBucketsQuery()

  const label = value ? (query.data?.find((c) => c.value == value)?.label ?? value) : null

  return <>{label}</>
}
